<pcg-bill-comparison *ngIf="canGoToForm" [BillComparisonFormId]="formId" [UserEmail]="email"></pcg-bill-comparison>
<h1 *ngIf="!canGoToForm">Invalid Form Link</h1>
<pcg-edit-link *ngIf="!canGoToForm" [url]="'/login'">
    Click here to login.
</pcg-edit-link>